import { useCallback } from "react"
import { Block, useStyletron } from "@mezo-org/mezo-clay"

import {
  selectIsRecoveryModeEnabled,
  setUpdateCollateralAmount,
  setUpdateCollateralRatio,
  setUpdateCollateralStrategy,
  useDappDispatch,
  useDappSelector,
} from "#/redux-state"
import { BorrowCollateralManagementStrategy } from "#/shared/types"
import { ComponentStepProps } from "#/ui/Modal"

import { BorrowProgress } from "../components"

import ManageActionItem from "./ManageActionItem"

export default function ManageAction({ onClickContinue }: ComponentStepProps) {
  const [css, theme] = useStyletron()
  const dispatch = useDappDispatch()

  const isRecoveryModeEnabled = useDappSelector(selectIsRecoveryModeEnabled)

  const chooseActionHandler = useCallback(
    (action: BorrowCollateralManagementStrategy) => {
      dispatch(setUpdateCollateralStrategy(action))
      dispatch(setUpdateCollateralAmount(""))
      dispatch(setUpdateCollateralRatio(""))
      onClickContinue()
    },
    [dispatch, onClickContinue],
  )

  return (
    <Block flex={1}>
      <BorrowProgress step={1} stepsCount={4} />
      <Block
        className={css({
          display: "flex",
          flexDirection: "column",
          gap: theme.sizing.scale300,
          width: "100%",
          paddingInline: theme.sizing.scale600,
        })}
      >
        <ManageActionItem
          header="Deposit collateral"
          description="Top up your collateral for greater flexibility"
          onClick={() =>
            chooseActionHandler(
              BorrowCollateralManagementStrategy.DEPOSIT_COLLATERAL,
            )
          }
        />
        <ManageActionItem
          header="Withdraw collateral"
          description={
            isRecoveryModeEnabled
              ? "Unavailable in recovery mode"
              : "Withdraw available collateral when needed"
          }
          hasError={isRecoveryModeEnabled}
          isDisabled={isRecoveryModeEnabled}
          onClick={() =>
            chooseActionHandler(
              BorrowCollateralManagementStrategy.WITHDRAW_COLLATERAL,
            )
          }
        />
      </Block>
    </Block>
  )
}
